import { render, staticRenderFns } from "./VendorsForm.vue?vue&type=template&id=de34efec&scoped=true&"
import script from "./VendorsForm.vue?vue&type=script&lang=js&"
export * from "./VendorsForm.vue?vue&type=script&lang=js&"
import style0 from "./VendorsForm.vue?vue&type=style&index=0&id=de34efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de34efec",
  null
  
)

export default component.exports